import { PushDeviceRow } from './PushDeviceRow';
const meta = {
    title: 'Features/Settings/Technicians/PushDeviceRow',
    component: PushDeviceRow,
    parameters: { layout: 'padded' }
};
export default meta;
export const Default = {
    args: { label: 'Device', value: 'iPhone16,2' }
};
/** Addressing fields are monospaced — they get compared character by character. */
export const Monospaced = {
    args: { label: 'Realm', value: 'inspectpoint-dev/prime1', monospace: true }
};
export const MissingValue = {
    args: { label: 'App version', value: null }
};
